import { Validator, AbstractControl, NG_VALIDATORS } from '@angular/forms';
import { Moment } from 'moment';
import moment from 'moment';

export abstract class AbstractMomentValidator implements Validator {
  constructor(public attributeName: string) {}

  validate(c: AbstractControl): { [key: string]: any } {
    if (c && c.value && c.value !== '') {
      const v: Moment = moment(c.value);
      const e = c.root.get(this.attributeName);

      if (v && e && e.value) {
        v.set('seconds', 0);
        const eValue: Moment = moment(e.value);
        eValue.set('seconds', 0);
        return this.compareValues(v, eValue);
      }
      if (e && e.errors) {
        this.clearTargetErrors(e);
      }
    }
    return null;
  }

  abstract compareValues(a: Moment, b: Moment): { [key: string]: any };

  abstract clearTargetErrors(e: any);
}
